var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05313 18.7594C6.72188 17.1938 5.86875 14.8781 5.8125 12.2812V11.7188C5.86875 9.12187 6.73125 6.80625 8.05313 5.24063C9.77812 3.00938 12.3094 2.00625 15.1688 2.00625C16.9312 2.00625 18.5906 2.12813 19.9969 3.06563C17.8875 1.1625 15.1031 0.009375 12.0469 0H12C5.37188 0 0 5.37188 0 12C0 18.4312 5.0625 23.6906 11.4281 23.9906C11.6156 24 11.8125 24 12 24C15.075 24 17.8781 22.8469 19.9969 20.9437C18.5906 21.8812 17.025 21.9188 15.2625 21.9188C12.4125 21.9281 9.76875 21 8.05313 18.7594Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0531 5.24072C9.14998 3.9376 10.575 3.15947 12.1312 3.15947C15.6281 3.15947 18.4594 7.11572 18.4594 12.0095C18.4594 16.9032 15.6281 20.8595 12.1312 20.8595C10.575 20.8595 9.15935 20.072 8.0531 18.7782C9.7781 21.0095 12.3375 22.4345 15.1875 22.4345C16.9406 22.4345 18.5906 21.9001 19.9969 20.9626C22.4531 18.7501 24 15.5532 24 12.0001C24 8.44697 22.4531 5.2501 19.9969 3.05635C18.5906 2.11885 16.95 1.58447 15.1875 1.58447C12.3281 1.58447 9.76873 3.0001 8.0531 5.24072Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.99904,
    y1: 0.3912,
    x2: 9.99904,
    y2: 23.6508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.0249,
    y1: 1.76232,
    x2: 16.0249,
    y2: 22.3342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.8986201e28775af549eb679613b42011.svg";
export { ForwardRef as ReactComponent };